export default __webpack_public_path__ + "static/media/clock.b02b309f.svg";